import { z } from 'zod'
import { FamilyRoleSchema } from '../enums.js'

export const EmploymentSchema = z.enum([
  'employee',
  'self_employed',
  'student',
  'retired',
])
export type Employment = z.infer<typeof EmploymentSchema>

export const MemberSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  role: FamilyRoleSchema,
  dob: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  // Employment status — drives OSVČ rules R-017/R-018. Nullable for existing rows.
  employment: EmploymentSchema.optional(),
})
export type Member = z.infer<typeof MemberSchema>
